import BaseDataProvider from "./BaseDataProvider";
import { gql } from "apollo-boost";
import _ from "lodash";

class SportCodesDataProvider extends BaseDataProvider {
  constructor(client) {
    //console.log("SportCodesDataProvider.constructor()");
    super(client);
    this.cachedListResponse = null;
  }

  async getList(resource, params) {
    console.log(
      "SportCodesDataProvider.getList(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    if (this.cachedListResponse) return this.cachedListResponse;
    const GET = gql`
      query {
        SportCodes {
          code
          label
        }
      }
    `;
    try {
      const response = await this.client.query({ query: GET });
      const data = response.data.SportCodes;
      this.cachedListResponse = {
        data: data.map((c) => {
          return { id: c.code, code: c.code, label: c.label };
        }),
        total: data.length
      };
      return this.cachedListResponse;
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async getMany(resource, params) {
    console.log(
      "SportCodesDataProvider.getMany(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const list = await this.getList(resource, params);
    const data = params.ids.map((id) => _.find(list.data, (s) => s.id === id));
    return { data: data };
  }
}

export default SportCodesDataProvider;
